var map = {
	"./canino_inf.svg": 6565,
	"./canino_sup.svg": 5952,
	"./endodoncia.svg": 3557,
	"./exodoncia.svg": 91,
	"./incisivo.svg": 6423,
	"./incisivo_central_inf.svg": 9057,
	"./incisivo_central_sup.svg": 4772,
	"./incisivo_lateral_inf.svg": 7567,
	"./incisivo_lateral_sup.svg": 7406,
	"./molar_deciduo_inf.svg": 7478,
	"./molar_deciduo_sup.svg": 6799,
	"./molar_inf.svg": 2716,
	"./molar_sup.svg": 9001,
	"./premolar_inf.svg": 4323,
	"./premolar_sup.svg": 2842,
	"./tornillo.svg": 7755
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 809;
module.exports = webpackAsyncContext;